import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import authApi from '@/api/auth'
import VueCookies from 'vue-cookies'

import paymentNoticeStore from '../modules/payment-notices/store'
import OfficialReceiptStore from '../modules/official-receipts/store'
import ReceiptStore from '../modules/receipts/store'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    authUser: null,
    selectedStudent: {},
    accessToken: null,
    isLockScreen: false
  },
  getters: {
    authenticated: state => state.accessToken !== null,
    accessToken: state => state.accessToken,
    permissionAllowCode: state =>
      state.authUser !== null ? state.authUser.permission_allow_code : null,
    userType: state =>
      state.authUser !== null ? state.authUser.user_type : null,
    guardian_type_id: state =>
      state.authUser !== null ? state.authUser.guardian_type_id : null,
    permissions: state =>
      state.authUser !== null ? state.authUser.permissions : null,
    defautlBranch: state =>
      state.authUser !== null ? state.authUser.defautlBranch : null,
    userProfile: state =>
      state.authUser !== null ? state.authUser.user_profile : null,
    cashierLocationId: state =>
      state.authUser !== null ? state.authUser.cashier_location_id : null,
    userId: state => (state.authUser !== null ? state.authUser.user_id : null),
    limitStringShow: state => text => {
      if (text != null) {
        let article = text.replace(/(<([^>]+)>)/gi, '')
        return article.length > 60 ? article.substring(0, 60) + '...' : article
      }
      return ''
    },
    isStaffLogin: state =>
      state.authUser !== null
        ? state.authUser.user_type.toLowerCase() == 'staff-api'
        : false,
    isTeacherLogin: state =>
      state.authUser !== null
        ? state.authUser.user_type.toLowerCase() == 'teacher-api'
        : false,
    isParentLogin: state =>
      state.authUser !== null
        ? state.authUser.user_type.toLowerCase() == 'parent-api'
        : false,
    isStudentLogin: state =>
      state.authUser !== null
        ? state.authUser.user_type.toLowerCase() == 'student-api'
        : false,
    children: state => (state.authUser !== null ? state.authUser.children : []),
    allow_duplicate_fee_type: state =>
      state.authUser !== null ? state.authUser.allow_duplicate_fee_type : null,
    company: state => (state.authUser !== null ? state.authUser.company : null),
    authPermissionAllow: state => permission_name => {
      let permissions = state.authUser !== null ? state.authUser.permissions : null;
      if (permissions) {
        if (permissions.includes(permission_name)) {
          return true;
        }
      }
      return false;
    },
  },
  mutations: {
    DRAWER_STATE(state, value) {
      state.drawer.model = value
    },
    MINI_DRAWER(state) {
      state.drawer.mini = !state.drawer.mini
    },
    setAuthUser(state, authUser) {
      if (authUser) {
        state.authUser = Object.assign(
          {},
          {
            user_name: authUser.user_name,
            full_name: authUser.full_name,
            // token_type: authUser.token_type,
            // refresh_token: authUser.refresh_token,
            // expires_in: authUser.expires_in,
            access_token: authUser.access_token,
            permission_allow_code: authUser.permission_allow_code,
            user_type: authUser.user_type,
            guardian_type_id: authUser.guardian_type_id,
            permissions: authUser.permissions,
            default_branch: authUser.default_branch,
            default_branch_id: authUser.default_branch_id,
            user_profile: authUser.user_profile,
            cashier_location_id: authUser.cashier_location_id,
            children: authUser.children,
            allow_duplicate_fee_type: authUser.allow_duplicate_fee_type,
            user_id: authUser.user_id,
            company: authUser.company
          }
        )

        localStorage.setItem('authUser', JSON.stringify(state.authUser))
      } else {
        state.authUser = null
        localStorage.clear()
      }
      state.accessToken = VueCookies.get('token')
    },
    setIsLock(state, value) {
      state.isLockScreen = value
      localStorage.setItem('!z_dy#@_____00111$%!@', value)
    },
    SET_SELECTED_STUDENT(state, student) {
      state.selectedStudent = student
      localStorage.setItem(
        'selectedStudent',
        JSON.stringify(state.selectedStudent)
      )
    }
  },
  actions: {
    init({ commit }) {
      const authUser = JSON.parse(localStorage.getItem('authUser'))
      const selectedStudent = JSON.parse(
        localStorage.getItem('selectedStudent')
      )
      if (selectedStudent) {
        commit('SET_SELECTED_STUDENT', selectedStudent)
      }
      if (authUser) {
        commit('setAuthUser', authUser)
      }
      commit(
        'setIsLock',
        parseInt(localStorage.getItem('!z_dy#@_____00111$%!@'))
      )
    },
    login({ commit }, formData) {
      return authApi.login(formData).then(response => {
        VueCookies.set('token', response.data.access_token, 'Session').set(
          'refresh_token',
          response.data.refresh_token,
          'Session'
        )
        commit('setAuthUser', response.data)
        if (response.data.children.length > 0) {
          commit('SET_SELECTED_STUDENT', response.data.children[0])
        }
        return Promise.resolve(response)
      })
    },
    logout({ commit }) {
      VueCookies.remove('token')
      VueCookies.remove('refresh_token')
      commit('setAuthUser', null)
    }
  },
  modules: {
    ...modules,
    paymentNoticeModule: paymentNoticeStore,
    officailReceiptModule: OfficialReceiptStore,
    receiptModule: ReceiptStore
  }
})

store.dispatch('init')

export default store
